import { render } from "./ModuleHrKnowledge.vue?vue&type=template&id=352f886a&scoped=true"
import script from "./ModuleHrKnowledge.vue?vue&type=script&lang=js"
export * from "./ModuleHrKnowledge.vue?vue&type=script&lang=js"

import "./ModuleHrKnowledge.vue?vue&type=style&index=0&id=352f886a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352f886a"]])

export default __exports__